/**
 * 宣传部稿库管理
 * created by: llh
 */
angular.module('propagandaManuscriptControlLeftModule', [])
    .directive('propagandaManuscriptControlLeft', ['$state', '$stateParams', '$q', 'messagePublishService', function($state, $stateParams, $q, messagePublishService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                classify: '='
            },
            templateUrl: './resourceCenter/propagandaManuscriptControl/left/left_tpl.html',
            link: function($scope, $attr, $elem) {
                initStatus();
                initData();

                /**
                 * [initStatus 初始化状态]
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        classify: {
                            '1': [],
                            '2': [],
                            '3': [],
                        },
                        id: $stateParams.groupid,
                    };
                    $scope.status = {
                        selectedItem: '',
                    };
                }

                /**
                 * [initData 初始化数据]
                 * @return {[type]} [description]
                 */
                function initData() {
                    if (angular.isUndefined($scope.classify) || JSON.stringify($scope.data.classify) != '{}') {return;}
                    matchLevels().then(function() {
                        if ($scope.data.id) {
                            autoLocation();
                        }
                    });
                }

                /**
                 * [matchLevels 处理数据来源]
                 * @return {[type]} [description]
                 */
                function matchLevels() {
                    var defer = $q.defer();
                    var n;
                    for (var i in $scope.classify) {
                        n = $scope.data.classify[$scope.classify[i].LEVELTYPE].filter(function(item){
                            return item.ID === $scope.classify[i].ID;
                        });
                        if (n.length == 0) {$scope.data.classify[$scope.classify[i].LEVELTYPE].push($scope.classify[i]);}
                    }
                    defer.resolve();
                    return defer.promise;
                }

                /**
                 * [autoLocation 自动定位选中项]
                 * @return {[type]} [description]
                 */
                function autoLocation() {
                    for (var i in $scope.classify) {
                        if ($scope.classify[i].ID === $scope.data.id) {
                            $scope.status.selectedItem = $scope.classify[i];
                            if ($scope.classify[i]) {messagePublishService.publish('secondLevelChange', $scope.classify[i]);}
                        }
                    }
                }
                /**
                 * [select 选择组织]
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.select = function(item) {
                    $scope.status.selectedItem = item;
                    let s = 'front.resourcectrl.propagandamanuscript.manuscriptcontrol';
                    $state.go(s, { 'groupid': item.ID }, {reload: s});
                };

                $scope.$watch('classify', function(newV, oldV) {
                    if (angular.isDefined(newV) && newV.length > 0) {
                        matchLevels().then(function () {
                            if ($scope.data.id) {
                                autoLocation();

                            } else {
                                messagePublishService.publish('secondLevelChange', $scope.classify[$scope.classify.length - 1]);
                            }
                        });

                    }
                });
            }
        };
    }]);
